import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';

import { IntegrationElementsActions } from '@recruitee/integrations/data';
import { Hotspots } from '@recruitee/integrations/types';

import { IntegrationsActions } from '../../client/integrations-client.types';
import { IntegrationEventActions } from './events';

@Injectable({ providedIn: 'root' })
export class IntegrationEventEffects {
  // eslint-disable-next-line max-lines-per-function
  private candidateOfferRefetch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        IntegrationEventActions.ElectronicSignatureRequestSentToCandidateEvent,
        IntegrationEventActions.ElectronicSignatureRequestRemovedEvent,
        IntegrationEventActions.CandidateSentToPartnerEvent,
        IntegrationEventActions.ReportUpdatedEvent,
        IntegrationEventActions.AppicalCandidateSentEvent,
        IntegrationEventActions.BryqReportCreatedEvent,
        IntegrationEventActions.InterviewMochaReportCreatedEvent,
        IntegrationEventActions.InterviewMochaEmailSentEvent,
        IntegrationEventActions.TestDomeReportCreatedEvent,
        IntegrationEventActions.CodilityReportCreatedEvent,
        IntegrationEventActions.CodilityCodeLiveEmailSentEvent,
        IntegrationEventActions.CheckrBackgroundCheckRequestSuccessEvent,
        IntegrationEventActions.CheckrInvitationCancelledEvent,
        IntegrationEventActions.PersonioCandidateSentEvent,
        IntegrationEventActions.BambooCandidateSentEvent,
      ),
      switchMap(({ payload }) => {
        const params = payload.context.hotspot.params;
        return [
          IntegrationElementsActions.fetchCollection({
            payload: {
              name: Hotspots.CandidateProfileBadges,
              params: { candidateId: params.candidateId },
            },
          }),
          IntegrationElementsActions.fetchCollection({
            payload: {
              name: Hotspots.CandidatesTableBadges,
              params: { candidateId: params.candidateId },
            },
          }),
          IntegrationElementsActions.fetchCollection({
            payload: {
              name: Hotspots.OfferPipelineBadges,
              params: { candidateId: params.candidateId },
            },
          }),
          IntegrationElementsActions.fetchCollection({
            payload: {
              name: Hotspots.CandidateProfileMore,
              params,
            },
          }),
          IntegrationElementsActions.fetchCollection({
            payload: {
              name: Hotspots.CandidateProfileOverview,
              params,
            },
          }),
        ];
      }),
    ),
  );

  private jobBoardsUpdate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        IntegrationEventActions.JobBoardPostingCreated,
        IntegrationEventActions.JobBoardPostingEdited,
        IntegrationEventActions.JobBoardPostingDeleted,
        IntegrationEventActions.HotelprofessionalsPostingCreated,
        IntegrationEventActions.HotelprofessionalsPostingEdited,
        IntegrationEventActions.HotelprofessionalsPostingDeleted,
        IntegrationEventActions.WerkenInEenHotelPostingCreated,
        IntegrationEventActions.WerkenInEenHotelPostingEdited,
        IntegrationEventActions.WerkenInEenHotelPostingDeleted,
      ),
      map(({ payload }) =>
        IntegrationsActions.updateJobBoards({
          payload: { offerId: payload.context.hotspot.params.offerId },
        }),
      ),
    ),
  );

  constructor(private actions$: Actions) {}
}
